//
// Copyright (c) 2011-2017 by Curalate, Inc.
//

import _ from "js/underscore-mixins";

(function() {
  angular.module('curalate').service('SearchFilterNestedCheckboxService', [
    'INDETERMINATE_CHECKBOX_STATES',
    'rx',
    'SearchFilterService',
    'TrackingService',
    function(
            INDETERMINATE_CHECKBOX_STATES,
            rx,
            SearchFilterService,
            TrackingService,
        ) {
      const NestedCheckbox = function(searchFilterSetName, key, value, parent) {
        this.checkboxState = INDETERMINATE_CHECKBOX_STATES.UNCHECKED;
        this.currentValueStream = new rx.ReplaySubject(1);
        this.searchFilterSetName = searchFilterSetName;
        this.key = key;
        this.value = value;
        this.valueStream = new rx.Subject();
        this.children = [];
        this.parent = parent;
        this.TRACKING_CATEGORY = TrackingService.CATEGORY_LIBRARY;
      };
      NestedCheckbox.prototype.init = function() {
        const self = this;
        if (this.parent) {
          const parentValueStream = this.parent.registerChild(this);

                    // parent renders first, so if the parent is checked, ignore our own value from the search-filter
          const currentParentValue = this.parent.getCurrentValue();
          if (currentParentValue === INDETERMINATE_CHECKBOX_STATES.CHECKED) {
            this.updateCheckboxState(INDETERMINATE_CHECKBOX_STATES.CHECKED);
            this.removeFromSearchFilter();
          } else { // if parent isn't CHECKED, we may have a value in the search-filter
            this.updateCheckboxState(this.checkboxStateFromSearchFilterValue(this.getSearchFilterValue()));
            this.notifyParentOfChange();
          }
          this.parentValueSub = parentValueStream.subscribe(self.computeStateFromParentUpdate.bind(self));
        } else {
          this.updateCheckboxState(this.checkboxStateFromSearchFilterValue(this.getSearchFilterValue()));
        }
      };
      NestedCheckbox.prototype.tearDown = function() {
        if (this.parentValueSub) {
          this.parentValueSub.unsubscribe();
        }
      };

      NestedCheckbox.prototype.checkboxStateFromSearchFilterValue = function(options) {
        const found = _(options).contains(this.value);
        return found ? INDETERMINATE_CHECKBOX_STATES.CHECKED : INDETERMINATE_CHECKBOX_STATES.UNCHECKED;
      };

      NestedCheckbox.prototype.getValue = function() {
        return this.currentValueStream;
      };
      NestedCheckbox.prototype.getCurrentValue = function() {
        return this.checkboxState;
      };
      NestedCheckbox.prototype.updateCheckboxState = function(newCheckboxState) {
        this.checkboxState = newCheckboxState;
        this.currentValueStream.next(this.checkboxState);
      };

      NestedCheckbox.prototype.registerChild = function(child) {
        this.children.push(child);
        return this.valueStream;
      };
      NestedCheckbox.prototype.anyCheckedChildren = function() {
        return _(this.children).some((child) => {
          return child.getCurrentValue() === INDETERMINATE_CHECKBOX_STATES.CHECKED;
        });
      };
      NestedCheckbox.prototype.anyIndeterminateChildren = function() {
        return _(this.children).some((child) => {
          return child.getCurrentValue() === INDETERMINATE_CHECKBOX_STATES.INDETERMINATE;
        });
      };
      NestedCheckbox.prototype.childChanged = function() {
        this.computeStateAfterChildUpdate();
      };
      NestedCheckbox.prototype.notifyParentOfChange = function() {
        if (this.parent) {
          this.parent.childChanged();
        }
      };
      NestedCheckbox.prototype.pushValueToChildren = function() {
        this.valueStream.next(this.checkboxState);
      };

      NestedCheckbox.prototype.getSearchFilterValue = function() {
        return SearchFilterService.getFilterValue(this.searchFilterSetName, this.key);
      };
      NestedCheckbox.prototype.addToSearchFilter = function() {
        SearchFilterService.addFilterValue(this.searchFilterSetName, this.key, this.value);
      };
      NestedCheckbox.prototype.removeFromSearchFilter = function() {
        SearchFilterService.removeFilterValue(this.searchFilterSetName, this.key, this.value);
      };

      NestedCheckbox.prototype.changeState = function(newCheckboxState, trackingLabel) {
        if (this.checkboxState === newCheckboxState) {
          return;
        }
        this.updateCheckboxState(newCheckboxState);
        if (newCheckboxState === INDETERMINATE_CHECKBOX_STATES.CHECKED) {
          this.addToSearchFilter();
          TrackingService.recordEvent(self.TRACKING_CATEGORY, TrackingService.ACTION_COLLECTIONS_SELECT_SOURCE, trackingLabel);
        } else {
          this.removeFromSearchFilter();
          TrackingService.recordEvent(self.TRACKING_CATEGORY, TrackingService.ACTION_COLLECTIONS_DESELECT_SOURCE, trackingLabel);
        }
        this.notifyParentOfChange();
        this.pushValueToChildren();
      };

      NestedCheckbox.prototype.computeStateFromParentUpdate = function(parentValue) {
        if (parentValue === INDETERMINATE_CHECKBOX_STATES.CHECKED) {
          this.updateCheckboxState(INDETERMINATE_CHECKBOX_STATES.CHECKED);
          this.removeFromSearchFilter();
          this.pushValueToChildren();
        } else if (parentValue === INDETERMINATE_CHECKBOX_STATES.UNCHECKED) {
          this.updateCheckboxState(INDETERMINATE_CHECKBOX_STATES.UNCHECKED);
          this.removeFromSearchFilter();
          this.pushValueToChildren();
        } else if (parentValue === INDETERMINATE_CHECKBOX_STATES.INDETERMINATE) {
          if (this.checkboxState === INDETERMINATE_CHECKBOX_STATES.CHECKED) {
            this.addToSearchFilter();
          }
        }
      };

      NestedCheckbox.prototype.computeStateAfterChildUpdate = function() {
        const anyChildrenChecked = this.anyCheckedChildren();
        const anyChildrenIndeterminate = this.anyIndeterminateChildren();
        if (anyChildrenChecked || anyChildrenIndeterminate) {
          this.updateCheckboxState(INDETERMINATE_CHECKBOX_STATES.INDETERMINATE);
          this.removeFromSearchFilter();
          this.notifyParentOfChange();
          this.pushValueToChildren();
        } else {
          this.updateCheckboxState(INDETERMINATE_CHECKBOX_STATES.UNCHECKED);
          this.removeFromSearchFilter();
          this.notifyParentOfChange();
        }
      };

      let nestedCheckboxes = [];
      this.addNestedCheckbox = function(searchFilterSetName, key, value, parent) {
        const newNestedCheckbox = new NestedCheckbox(searchFilterSetName, key, value, parent);
        nestedCheckboxes.push(newNestedCheckbox);
        newNestedCheckbox.init();
        return newNestedCheckbox;
      };
      this.getNestedCheckbox = function(searchFilterSetName, key, value) {
        return _(nestedCheckboxes).find((nestedCheckbox) => {
          return nestedCheckbox.searchFilterSetName === searchFilterSetName && nestedCheckbox.key === key && nestedCheckbox.value === value;
        });
      };

      this.clear = function() {
        _(nestedCheckboxes).each((nestedCheckbox) => {
          nestedCheckbox.tearDown();
        });
        nestedCheckboxes = [];
      };
    },
  ]);
})();
